'use client';
function setAddMany(r, o, t = false) {
    for (let n of o)(t || n) && r.add(n);
    return r;
}
function setToString(r, o = ' ') {
    return Array.from(r).filter(Boolean).join(o);
}

export { setAddMany, setToString };
